import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Select } from '@wikifactory/voxel-ui';
import { themes } from 'styles/themes/wikifactoryNew';
import { PointOnSurfaceIcon } from 'icons';
import { Icon } from 'components';
import { useMeasurementMenu } from '../measurements/useMeasurementMenu';
import FloatingWindow from './floatingWindow';

enum MeasurementMethod {
  PointToPoint = 'PointToPoint',
  Dimension = 'Dimension',
}

type FloatingMeasurementWindowProps = {
  title: React.ReactNode;
  onClose: () => void;
};

const LabelItem = ({
  icon,
  label,
}: {
  icon: React.ReactNode;
  label: string;
}) => {
  return (
    <div className='flex items-center'>
      {icon}
      <div className='ml-1 pt-1 text-sm'>{label}</div>
    </div>
  );
};

export const FloatingMeasurementWindow = observer(
  ({ title, onClose }: FloatingMeasurementWindowProps) => {
    const {
      tooltip,
      previewElement,
      emptyContent,
      renderFromToElement,
      shouldNotEmpty,
      shouldHaveOperatorBar,
      operatorBar,
      descriptionInfo,
      // renderRotateElement,
      // renderOffsetElement,
      deleteOrDiscardBtn,
      // disableFromSelect,
      // disableDimension,
      handleClickDimension,
      //stickyOptionGroup,
      shouldSelectedDimension,
      handleClickPointToPoint,
    } = useMeasurementMenu();

    const [measurementWay, setMeasurementWay] = useState<MeasurementMethod>(
      MeasurementMethod.PointToPoint,
    );

    useEffect(() => {
      setMeasurementWay(
        shouldSelectedDimension
          ? MeasurementMethod.Dimension
          : MeasurementMethod.PointToPoint,
      );
    }, [shouldSelectedDimension]);

    const measurementMapFn = {
      [MeasurementMethod.Dimension]: handleClickDimension,
      [MeasurementMethod.PointToPoint]: handleClickPointToPoint,
    };

    const handleChangeMethodSelect = (value: MeasurementMethod) => {
      measurementMapFn[value]?.();
    };

    const methodOptions = [
      {
        disabled: false,
        value: MeasurementMethod.PointToPoint,
        label: (
          <LabelItem label='Point to point' icon={<PointOnSurfaceIcon />} />
        ),
      },
      {
        disabled: false,
        value: MeasurementMethod.Dimension,
        label: (
          <LabelItem
            label='Dimension'
            icon={
              <Icon
                className=' mx-1'
                name='geometry'
                size='default'
                viewBox='0 0 40 40'
              />
            }
          />
        ),
      },
    ];

    const newSelectedStyle = {
      border: 'none',
    };

    return (
      <FloatingWindow
        title={title}
        onClose={onClose}
        inner={
          <div>
            {tooltip}
            <div className='flex items-center border-b border-wfGrey100'>
              <Select
                autoFocus
                value={measurementWay}
                options={methodOptions}
                defaultValue={MeasurementMethod.PointToPoint}
                onChange={(e: Record<string, any>) => {
                  handleChangeMethodSelect(e.target.value);
                }}
                sx={{
                  '& fieldset': newSelectedStyle,
                  '&:hover .MuiOutlinedInput-notchedOutline': newSelectedStyle,
                  notchedOutline: newSelectedStyle,
                }}
                style={{
                  width: 180,
                  fontSize: 14,
                  border: 'none',
                  overflow: 'hidden',
                }}
              />

              {renderFromToElement && (
                <div className='px-4 text-sm h-10 items-center text-center flex-1 text-black'>
                  {renderFromToElement}
                </div>
              )}
            </div>
            {emptyContent && <div className='px-4 py-2'>{emptyContent}</div>}
            {shouldNotEmpty && (
              <>
                {(shouldHaveOperatorBar || previewElement) && (
                  <div className='px-4 py-1 flex justify-between border-b border-wfGrey100 items-center'>
                    {previewElement}
                    <div className='flex justify-end items-center'>
                      {operatorBar}
                      <div className='ml-1'>{deleteOrDiscardBtn}</div>
                    </div>
                  </div>
                )}

                {descriptionInfo && (
                  <div className='px-4 py-2 border-b border-wfGrey100 flex items-center'>
                    {descriptionInfo}
                  </div>
                )}
              </>
            )}
          </div>
        }
      />
    );
  },
);
